export enum ETipoInscricaoEstadual {
    ContribuinteICMS = 1,
    ContribuinteIsento = 2,
    NaoContribuinte = 9
}
